import { FaCreditCard } from "react-icons/fa6";
import styles from "./BankAccountBox.module.css";

function BankAccountBox({ item }) {
  return (
    <div
      className={`buttonUi w-100 d-flex py-2 px-3 my-3 column-gap-3 ${styles.box}`}
    >
      <div className="d-flex align-items-center">
        <FaCreditCard size="24" color="#11ae81" />
      </div>
      <div className="d-flex flex-wrap align-items-center w-100 column-gap-4 row-gap-2">
        <p>
          <span>نام: </span>
          <strong>{item.name}</strong>
        </p>

        <p>
          <span>نام خانوادگی: </span>
          <strong>{item.lName}</strong>
        </p>

        <p>
          <span>نام بانک: </span>
          <strong>{item.bankName}</strong>
        </p>

        <div className="w-100 d-flex flex-wrap justify-content-between">
          <p>
            <span>شبا: </span>
            <strong>{item.shabaNumber}</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default BankAccountBox;
